import React, { useState, useEffect } from "react";
import axios from "axios";

const UpdateTimesheetModal = ({ show, handleClose, taskInfo }) => {
  const [formData, setFormData] = useState({ ...taskInfo });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  //   const handleSubmit = (e) => {
  //     e.preventDefault();
  //     axios
  //       .put(`/api/timesheet/${timesheetId}`, formData)
  //       .then((response) => {
  //         console.log("Timesheet updated successfully:", response.data);
  //         handleClose(); // Close modal on success
  //       })
  //       .catch((error) => {
  //         console.error("Error updating timesheet:", error);
  //       });
  //   };

  if (!show) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg w-1/2 p-6 relative">
        <h2 className="text-2xl font-bold mb-4">Update Timesheet Entry</h2>
        <form className="space-y-4">
          <div>
            <label className="block text-gray-700">Entry Date</label>
            <input
              type="text"
              name="field_entrydate"
              value={formData.field_entrydate}
              onChange={handleChange}
              className="w-full border border-gray-300 p-2 rounded"
            />
          </div>
          <div>
            <label className="block text-gray-700">Ticket Number</label>
            <input
              type="text"
              name="field_ticket_number"
              value={formData.field_ticket_number}
              onChange={handleChange}
              className="w-full border border-gray-300 p-2 rounded"
            />
          </div>
          <div>
            <label className="block text-gray-700">Project ID</label>
            <input
              type="text"
              name="field_proj"
              value={formData.field_proj}
              onChange={handleChange}
              className="w-full border border-gray-300 p-2 rounded"
            />
          </div>
          <div>
            <label className="block text-gray-700">Task</label>
            <input
              type="text"
              name="field_entrytask"
              value={formData.field_entrytask}
              onChange={handleChange}
              className="w-full border border-gray-300 p-2 rounded"
            />
          </div>
          <div>
            <label className="block text-gray-700">Description</label>
            <textarea
              name="body"
              value={formData.body}
              onChange={handleChange}
              className="w-full border border-gray-300 p-2 rounded"
            />
          </div>
          <div>
            <label className="block text-gray-700">Time Spent</label>
            <input
              type="text"
              name="field_time_spent"
              value={formData.field_time_spent}
              onChange={handleChange}
              className="w-full border border-gray-300 p-2 rounded"
            />
          </div>
          <div className="flex justify-end space-x-2">
            <button
              type="button"
              onClick={handleClose}
              className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
            >
              Update
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UpdateTimesheetModal;
